import React from "react";
import { Scissors } from "lucide-react";
import { useApp } from "../context/AppContext";

const SIDES = ["right", "left", "top", "base"];

function thickOf(fields, side) {
  return fields[`${side}_thick`] || "";
}

/** One opening's pieces → compact rows (side · length · thickness). */
function PieceRows({ item, t }) {
  const f = item.fields || {};
  const isCapa = item.kind === "capa";
  const isL = item.kind === "ltrim";
  const rows = SIDES.filter((s) => f[s] || (s === "base" && item.kind === "brickmold" && f.base_type)).map((s) => {
    let label = t(`trim_side_${s}`);
    if (s === "base" && item.kind === "brickmold") label = f.base_type === "nosing" ? "Nosing" : f.base_type === "none" ? t("trim_no_base") : label;
    return { side: label, len: f[s] || "", thick: isL ? thickOf(f, s) : "" };
  });
  return (
    <table className="w-full text-[12px] tabular-nums" data-testid={`trim-item-${item.n}`}>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i} className="border-t border-black/5 dark:border-white/10">
            <td className="py-0.5 pr-2 text-muted-foreground w-[46%]">{r.side}</td>
            <td className="py-0.5 pr-2 font-mono-plex font-semibold">{r.len ? `${r.len}"` : "—"}</td>
            {isL && <td className="py-0.5 text-muted-foreground whitespace-nowrap">{r.thick ? `${t("trim_thick_short")} ${r.thick}"` : ""}</td>}
          </tr>
        ))}
        {isCapa && (
          <>
            {f.inside && <tr className="border-t border-black/5 dark:border-white/10"><td className="py-0.5 pr-2 text-muted-foreground">{t("trim_inside")}</td><td className="py-0.5 font-mono-plex font-semibold" colSpan={2}>{f.inside}"</td></tr>}
            {f.face && <tr className="border-t border-black/5 dark:border-white/10"><td className="py-0.5 pr-2 text-muted-foreground">{t("trim_face")}</td><td className="py-0.5 font-mono-plex font-semibold" colSpan={2}>{f.face}"</td></tr>}
            {(f.finish || f.siding) && (
              <tr className="border-t border-black/5 dark:border-white/10">
                <td className="py-0.5 pr-2 text-muted-foreground">{f.finish === "reforco" ? t("trim_reforco") : "Siding"}</td>
                <td className="py-0.5 font-mono-plex font-semibold" colSpan={2}>{f.siding ? `${f.siding}"` : "—"}</td>
              </tr>
            )}
          </>
        )}
      </tbody>
    </table>
  );
}

/** Trim notes report (Buddy trim mode) grouped by window/door. */
export function TrimReportBubble({ message }) {
  const { t } = useApp();
  const items = message.meta?.items || [];
  const groups = [];
  items.forEach((it) => {
    const key = `${it.location || ""}|${it.label || ""}`;
    let g = groups.find((x) => x.key === key);
    if (!g) { g = { key, location: [it.location, it.label].filter(Boolean).join(" ") || "—", items: [] }; groups.push(g); }
    g.items.push(it);
  });
  return (
    <div className="mb-1 space-y-2" data-testid="trim-report">
      <div className="flex items-center gap-2">
        <Scissors className="h-4 w-4 text-primary" />
        <span className="font-bold text-xs uppercase tracking-wide text-primary">{t("trim_report")}</span>
        {message.meta?.location && <span className="text-[11px] text-muted-foreground truncate">· {message.meta.location}</span>}
      </div>
      {groups.map((g) => (
        <div key={g.key} className="rounded-lg bg-black/5 dark:bg-white/5 px-2.5 py-1.5" data-testid="trim-group">
          <div className="text-[13px] font-semibold truncate" data-testid="trim-group-location">{g.location}</div>
          {g.items.map((it) => (
            <div key={it.n} className="mt-1">
              <div className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{it.kind_label || it.kind}</div>
              <PieceRows item={it} t={t} />
              {it.note && <div className="text-[11px] italic text-muted-foreground mt-0.5">{it.note}</div>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
